'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$63() {
  this.blk = null;
  this.bll = false;
}
export { $c_Lpresto_PrestoRouter$$anon$63 as $c_Lpresto_PrestoRouter$$anon$63 };
$p = $c_Lpresto_PrestoRouter$$anon$63.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$63;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$63() {
}
export { $h_Lpresto_PrestoRouter$$anon$63 as $h_Lpresto_PrestoRouter$$anon$63 };
$h_Lpresto_PrestoRouter$$anon$63.prototype = $p;
$p.bW = (function() {
  if ((!this.bll)) {
    this.blk = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_T$package$EmptyTuple$();
    this.bll = true;
  }
  return this.blk;
});
$p.P = (function() {
  return this.bW();
});
var $d_Lpresto_PrestoRouter$$anon$63 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$63, "presto.PrestoRouter$$anon$63", ({
  Ov: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$63 as $d_Lpresto_PrestoRouter$$anon$63 };
//# sourceMappingURL=presto.-Presto-Router$$anon$63.js.map
